/**
 * The SSO error keys the SPA will render (CR-SSO-INVITE-PX-2026-09-26, spec
 * R.5.4). The callback hands a raw key back in `?error=` / `?ssoError=`; only an
 * allowlisted key is ever translated, and anything else becomes the generic
 * message — never the raw key, and never a server-authored sentence.
 */

export const SSO_ERROR_KEYS: ReadonlySet<string> = new Set([
  'oauth.generic',
  'oauth.invite.required',
  'oauth.invite.invalid',
  'oauth.invite.email-mismatch',
  'oauth.invite.email-unverified',
  'oauth.provider.denied',
  'oauth.provider.unconfigured',
  'oauth.callback.state-invalid',
  'oauth.code.invalid',
  'oauth.exchange.failed',
  'oauth.exchange.code-invalid',
  'auth.account.deactivated'
])

/** The key to render: `raw` when allowlisted, otherwise the generic SSO key. */
export function ssoErrorKey(raw: string | null | undefined): string {
  return raw !== null && raw !== undefined && SSO_ERROR_KEYS.has(raw) ? raw : 'oauth.generic'
}

/**
 * The alert tone: `notice` only for a cancelled sign-in (the person's own
 * choice, nothing to fix); every other key is a `problem`.
 */
export function ssoErrorTone(key: string): 'problem' | 'notice' {
  return key === 'oauth.provider.denied' ? 'notice' : 'problem'
}
